'use client'

import { Section } from '@/models/Form'
import { Col, Row, Typography } from 'antd'
import SBDynamicFormItem from './SBDynamicFormItem'

const { Title } = Typography

interface Props {
  pathPrefix: string[]
  section: Section
}

const SBDynamicFormSection = ({ pathPrefix, section }: Props) => {
  return (
    <Row gutter={[16, 16]}>
      {section.title && section.displayTitleInForm && (
        <Col span={24}>
          <Title level={5}>{section.title}</Title>
        </Col>
      )}
      {section.items.map((item) => (
        <SBDynamicFormItem key={item.id} item={item} pathPrefix={pathPrefix} />
      ))}
    </Row>
  )
}

type SBDynamicFormSectionType = {
  Step: typeof SBDynamicFormSection
}

export { SBDynamicFormSection, type SBDynamicFormSectionType }
